import { useEffect } from 'react';
import { trackFormError } from 'Utils/Analytics';

import './Field.css';

const excludedErrors = [];

const Field = (props) => {
  const { meta, fieldTouched, pageStartSource, pagePlanFlowType, children } = props;

  const trackError = () => {
    if (meta) {
      const { error, touched, active, form: formName } = meta;
      if (error && excludedErrors.indexOf(error) === -1 && touched && !active) {
        trackFormError(
          formName,
          {
            status: 1000,
            message: error,
          },
          {
            page_start_source: pageStartSource || 'other',
            page_plan_flow_type: pagePlanFlowType || undefined,
          }
        );
      }
    }
  };

  useEffect(() => {
    trackError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    trackError();
    if (fieldTouched && meta.touched) {
      fieldTouched(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta, fieldTouched]);

  return children;
};

export default Field;
